<div class="dashboard-container container-fluid px-0 resources-page">
  <div class="row g-0 vh-100 overflow-hidden">
    <div
      v-if="!is_mobile"
      class="col-auto sidebar-wrapper sidebar-offset d-flex flex-column flex-shrink-0 position-sticky top-0 vh-100 overflow-hidden overflow-x-visible"
      :class="{ 'sidebar-collapsed': sidebar_collapsed }"
    >
      <div class="h-100 overflow-auto overflow-x-hidden no-scrollbar">
        <PropertySidebar
          v-if="selected_property"
          :active_property="selected_property"
          :properties="tiles"
          :active_item="active_menu_item"
          :can_view_portfolio="can_view_portfolio"
          @switch-property="handleTileClick"
          @go-back="goBack"
          @property-menu-selected="handlePropertyMenuSelected"
        />
      </div>
    </div>

    <div v-if="is_mobile && mobile_sidebar_open" class="mobile-sidebar-overlay" @click.self="close_sidebar">
      <div class="mobile-sidebar-panel h-100 overflow-hidden">
        <div class="h-100 overflow-auto overflow-x-hidden">
          <PropertySidebar
            v-if="selected_property"
            :active_property="selected_property"
            :properties="tiles"
            :active_item="active_menu_item"
            :can_view_portfolio="can_view_portfolio"
            @switch-property="handleTileClick"
            @go-back="goBack"
            @property-menu-selected="handlePropertyMenuSelected"
            @close-sidebar="close_sidebar"
          >
            <template #sidebar-header-actions>
              <button class="sidebar-close-btn" @click="close_sidebar" aria-label="Close sidebar">
                <i class="bi bi-x-lg"></i>
              </button>
            </template>
          </PropertySidebar>
        </div>
      </div>
    </div>

    <button v-if="!is_mobile" class="sidebar-collapse-btn btn btn-sm btn-dark float-start" @click="toggleSidebar">
      <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
    </button>

    <div class="col vh-100 d-flex flex-column overflow-hidden no-scrollbar">
      <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="showAssistant = true"
        @toggle-mobile-sidebar="toggle_mobile_sidebar"
      />

      <BolideAssistant
        :is_open="showAssistant"
        :scope="assistant_scope"
        @close-assistant="showAssistant = false"
      />

      <main
        class="dashboard-main resources-main flex-grow-1 overflow-auto overflow-x-hidden"
        :class="{ 'dashboard-main-assist-open': showAssistant }"
      >
        <div class="resources-content p-3 p-md-4">
        <!-- Scheduled reports preview. Automated generation is not wired yet. -->
        <section class="container-fluid px-0 mb-5">
          <div class="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-3 mb-4">
            <div>
              <h6 class="fw-semibold text-white mb-1">Scheduled Reports</h6>
              <p class="text-white-50 mb-0 text-sm">
                Automated reports the system will generate on a recurring schedule.
              </p>
            </div>
          </div>

          <div class="row g-4">
            <div
              v-for="schedule in scheduled_report_examples"
              :key="schedule.report_type + schedule.period_label"
              class="col-md-6 col-xl-4"
            >
              <article class="glass-card resources-team-card rounded-4 h-100 d-flex flex-column">
                <div class="d-flex align-items-start justify-content-between gap-2 mb-3">
                  <div class="min-w-0">
                    <p class="text-white fw-semibold mb-1 text-xs text-truncate">{{ schedule.report_type }}</p>
                    <p class="text-white-50 mb-0 text-xs">{{ schedule.period_label }}</p>
                  </div>
                  <span class="badge rounded-pill" :class="report_status_badge_class(schedule.status)">
                    {{ schedule.status }}
                  </span>
                </div>

                <p class="text-white-50 text-xs mb-4">
                  {{ selected_property?.title || "Selected property" }} {{ schedule.title }}
                </p>

                <div class="d-flex align-items-center mb-4">
                  <div class="icon-box me-3">
                    <i class="bi bi-calendar-event text-white"></i>
                  </div>
                  <span class="text-white-50 text-xs">Generated {{ schedule.generated_at }}</span>
                </div>

                <button
                  type="button"
                  class="btn btn-primary btn-sm mt-auto d-flex align-items-center justify-content-center gap-2"
                >
                  <i class="bi bi-download"></i>
                  Download PDF
                </button>
              </article>
            </div>
          </div>

          <p class="text-white-50 text-xs mt-3 mb-0">
            Scheduling isn't live yet — this is a preview of how upcoming automated reports will appear.
          </p>
        </section>

        <!-- Generated reports -->
        <section class="container-fluid px-0">
          <div class="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-3 mb-4">
            <div>
              <h6 class="fw-semibold text-white mb-1">Generated Reports</h6>
              <p class="text-white-50 mb-0 text-sm">
                Reports you've generated through Jeffrey for {{ selected_property?.title || "the selected property" }}
              </p>
            </div>

            <span v-if="reports.length" class="badge rounded-pill settings-soft-badge align-self-start align-self-md-center">
              {{ reports.length }} report{{ reports.length === 1 ? "" : "s" }}
            </span>
          </div>

          <div v-if="reports_error" class="glass-card rounded-4 mb-4 border border-danger-subtle">
            <p class="text-white-50 text-xs mb-0">{{ reports_error }}</p>
          </div>

          <div v-if="reports_loading" class="glass-card rounded-4 text-center">
            <p class="text-white-50 text-xs mb-0">Loading reports...</p>
          </div>

          <div v-else-if="reports.length" class="row g-4">
            <div
              v-for="report in reports"
              :key="report.id"
              class="col-md-6 col-xl-4"
            >
              <article class="glass-card resources-team-card rounded-4 h-100 d-flex flex-column">
                <div class="d-flex align-items-start justify-content-between gap-2 mb-3">
                  <div class="min-w-0">
                    <p class="text-white fw-semibold mb-1 text-xs text-truncate">{{ format_report_type(report.report_type) }}</p>
                    <p class="text-white-50 mb-0 text-xs">{{ report.period_label || "" }}</p>
                  </div>
                  <span class="badge rounded-pill" :class="report_status_badge_class(report.status)">
                    {{ report.status }}
                  </span>
                </div>

                <p class="text-white-50 text-xs mb-4">{{ report.title }}</p>

                <div class="d-flex align-items-center mb-4">
                  <div class="icon-box me-3">
                    <i class="bi bi-calendar-event text-white"></i>
                  </div>
                  <span class="text-white-50 text-xs">Generated {{ format_report_date(report.created_at) }}</span>
                </div>

                <button
                  type="button"
                  class="btn btn-primary btn-sm mt-auto d-flex align-items-center justify-content-center gap-2"
                  :disabled="downloading_report_id === report.id"
                  @click="handle_download_report(report)"
                >
                  <i class="bi bi-download"></i>
                  {{ downloading_report_id === report.id ? "Downloading..." : "Download PDF" }}
                </button>
              </article>
            </div>
          </div>

          <div v-else class="glass-card rounded-4 text-center">
            <h5 class="text-white fw-bold mb-1">No reports available</h5>
            <p class="text-white-50 text-xs mb-0">Reports generated for this property will appear here.</p>
          </div>
        </section>
        </div>
      </main>

      <button
        v-if="is_mobile && !showAssistant"
        class="floating-assistant-btn btn btn-primary d-md-none"
        @click="showAssistant = true"
        aria-label="Open assistant"
      >
        <i class="bi bi-robot fs-5"></i>
      </button>
    </div>
  </div>
</div>
